import React from 'react';

import { Error as ErrorComponent } from '@pages/_error';
import { useError } from '@components/providers/ErrorProvider';

type ErrorHandlerProps = {
  children: React.ReactNode;
};

export const ErrorHandler = ({ children }: ErrorHandlerProps): JSX.Element => {
  const { error } = useError();

  if (error) {
    return <ErrorComponent errorType={error.statusCode === 404 ? 'ERROR_404' : 'SIMPLE_ERROR'} errorDetail={error} />;
  }

  return <>{children}</>;
};
export default ErrorHandler;
